import type { ReactNode } from 'react';

interface Overview {
  topic: string; latest_update: string; open_questions: string[]; next_step: string;
  method: 'ai' | 'snapshot'; partial: boolean; message_count: number;
}
export function RequestOverview({overview, status, labels}: {overview: Overview; status: ReactNode; labels: {
  title: string; ai: string; snapshot: string; latest: string; questions: string; next: string;
  partial: string; review: string; messages: string;
}}) {
  return <section className="fd-request-overview" aria-label={labels.title}>
    <header><div><h2>{labels.title}</h2><span>{overview.method === 'ai' ? labels.ai : labels.snapshot}</span></div>{status}</header>
    <p className="fd-request-overview__topic">{overview.topic}</p>
    <dl><div><dt>{labels.latest}</dt><dd>{overview.latest_update}</dd></div>
      {overview.open_questions.length > 0 && <div><dt>{labels.questions}</dt><dd><ul>{overview.open_questions.map((question, index) => <li key={index}>{question}</li>)}</ul></dd></div>}
      <div><dt>{labels.next}</dt><dd>{overview.next_step}</dd></div></dl>
    {overview.partial && <p className="fd-request-overview__partial">{labels.partial}</p>}
    <footer>{labels.messages}{overview.method === 'ai' && <> · {labels.review}</>}</footer>
  </section>;
}
